/* istanbul ignore file */
import { Routes, Route } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { createRoute } from 'framework/routing';
import ViewProjectDashboard from './list';
import { READ_PROJECT_DASHBOARD } from './ProjectDashboardService';
import { PROJECT_DASHBOARD_PATH } from './dashboardRouting';

const useProjectDashboardRoute = () => {
  return createRoute({
    listRoute: PROJECT_DASHBOARD_PATH,
  });
};

const ProjectDashboardRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useProjectDashboardRoute();

  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={READ_PROJECT_DASHBOARD}>
            <ViewProjectDashboard />
          </GlobalProtectedRoute>
        }
      />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default ProjectDashboardRouter;
